import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import {
  OrderDonorCoveredFeesSlice,
  OrderDonorCoveredFeesValue,
} from './order-donor-covered-fees-types'

export const DCF_GROSS_ADJUSTMENTS_INITIAL_STATUS = {
  applied_application_fee_percent: null,
  applied_processor_fee_percent: null,
  applied_raw_processor_fee_flat: null,
  applied_flex_rate_percent: null,
  raw_application_fee_amount: null,
  raw_processor_fee_amount: null,
  raw_flex_rate_amount: null,
  raw_initial_gross_amount: null,
}

const DCF_INITIAL_STATE: OrderDonorCoveredFeesSlice = {
  value: {
    isLoading: true,
    isChecked: false,
    fee: 0,
    totalAmount: 0,
    ...DCF_GROSS_ADJUSTMENTS_INITIAL_STATUS,
  },
}

const orderDonorCoveredFeesSlice = createSlice({
  name: 'dcf',
  initialState: DCF_INITIAL_STATE,
  reducers: {
    setValue: (state, action: PayloadAction<OrderDonorCoveredFeesValue>) => {
      return { ...state, value: action.payload }
    },
  },
})

export default orderDonorCoveredFeesSlice
